module.exports = __webpack_public_path__ + "static/assets/7301e34837707b4cd7f1656fbf4816be.svg";